// extracted by mini-css-extract-plugin
module.exports = {"varSpDown2":"0.5rem","varSpUp4":"2rem","varSpDown1":"0.75rem","container":"container--4075d","titleContainer":"titleContainer--e9bc9","title":"title--ea02f"};